import { useMutation } from '@tanstack/react-query';

import { useToast } from '@aslanpay/portal-common-lib';

import ReconciliationsApiHandler from 'app/services/reconciliationsApiHandler';

import { ReconciliationReportRequest } from 'app/types/reconciliations';

/** Downloads a reconciliation run's report as CSV, limited to one company when one is given. */
const useDownloadReconciliationReport = () => {
  const toast = useToast();

  return useMutation<void, Error, ReconciliationReportRequest>(
    (request) => ReconciliationsApiHandler.downloadReconciliationReport(request),
    {
      onSuccess: () => {
        toast({ position: 'top-right', status: 'success', title: 'Report downloaded' });
      },
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: 'Sorry, it was not possible to download the report. Please try again.',
        });
      },
    }
  );
};

export default useDownloadReconciliationReport;
